import React from "react";

export default function PageLoader({ message = "Loading...", fullScreen = false }) {
  return (
    <div
      className={
        fullScreen
          ? "d-flex align-items-center justify-content-center min-vh-100 bg-white agent-page-loader"
          : "text-center py-5 agent-page-loader"
      }
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" aria-hidden="true" />
        <p className="mb-0 text-secondary">{message}</p>
      </div>
    </div>
  );
}
